import { useMemo } from 'react';
import { useConfig } from '../../eliot-components/src/ConfigProvider/hooks';
import { useAuthUser } from '../../contexts/AuthProvider/hooks';
import { getKnownIssuesByReports } from './provider';
import { MedisanteOrgReport } from '../Dashboard/types';
import { MedisanteTargetSystem } from '../TargetSystems/types';
import { useGetReportsQuery } from '../../store/api-slice';

export const useKnownIssues = (reports: MedisanteOrgReport[] = []) => {
  const knownIssues = useMemo(
    () => getKnownIssuesByReports(reports),
    [reports]
  );
  const numberOfIssues = Object.values(knownIssues).reduce(
    (sum, issue) => (sum += !!issue ? issue.deviceCount : 0),
    0
  );

  const state = useMemo(
    () => ({ numberOfIssues, knownIssues }),
    [knownIssues, numberOfIssues]
  );

  return state;
};

export const useCachedKnownIssues = () => {
  const config = useConfig();
  const { authUser } = useAuthUser();

  const { data: reports = [], isFetching: isLoading } = useGetReportsQuery({
    apiBaseURL: config.apiBaseURL,
    orgs: authUser.selectedOrgs,
    filters: [],
  });

  const knownIssues = useMemo(
    () => getKnownIssuesByReports(reports),
    [reports]
  );
  const numberOfIssues = Object.values(knownIssues).reduce(
    (sum, issue) => (sum += !!issue ? issue.deviceCount : 0),
    0
  );

  const state = useMemo(
    () => ({ numberOfIssues, knownIssues }),
    [knownIssues, numberOfIssues]
  );

  return { state, isLoading };
};

export const useConfigurationWarning = (
  _: MedisanteOrgReport[],
  targetSystems: MedisanteTargetSystem[]
) => {
  return useMemo(() => {
    let ids: string[] = [];
    return targetSystems.filter((ts) => {
      return ids.indexOf(ts.id) !== -1;
    });
  }, [targetSystems]);
};
